import { Box, Skeleton } from '@mui/material';

export interface WidgetTrendChartSkeletonProps {
  /** Height of the chart area placeholder (matches trend chart widgets). */
  chartHeight?: number;
  /** When false, only the chart area skeleton is shown. */
  showCurrencyTitleSkeleton?: boolean;
}

/**
 * Placeholder for dashboard / embeddable trend chart widgets while data loads or refetches.
 */
export function WidgetTrendChartSkeleton({
  chartHeight = 340,
  showCurrencyTitleSkeleton = true,
}: WidgetTrendChartSkeletonProps) {
  return (
    <Box aria-busy='true'>
      {showCurrencyTitleSkeleton && (
        <>
          <Skeleton
            variant='text'
            width={200}
            height={40}
          />
          <Skeleton
            variant='text'
            width={150}
            height={20}
            sx={{ mb: 2 }}
          />
        </>
      )}
      <Skeleton
        variant='rectangular'
        width='100%'
        height={chartHeight}
      />
    </Box>
  );
}
